if (!customElements.get('twa-studio-gallery')) {
  customElements.define(
    'twa-studio-gallery',
    class extends HTMLElement {
      connectedCallback() {
        this.index = 0;
        this.cards = [...this.querySelectorAll('.twa-studio-gallery__card')];
        this.controller = new AbortController();
        this.addEventListener(
          'click',
          (event) => {
            const nav = event.target.closest('[data-direction]');
            if (nav) this.move(Number(nav.dataset.direction));
          },
          { signal: this.controller.signal },
        );
        this.addEventListener(
          'keydown',
          (event) => {
            if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
            event.preventDefault();
            this.move(event.key === 'ArrowLeft' ? -1 : 1);
          },
          { signal: this.controller.signal },
        );
      }
      move(direction) {
        this.index = (this.index + direction + this.cards.length) % this.cards.length;
        this.cards.forEach((card, index) => {
          card.setAttribute('aria-hidden', String(index !== this.index));
          card.inert = index !== this.index;
        });
        this.querySelector('figcaption').textContent = this.cards[this.index].dataset.caption;
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    },
  );
}
